import {Injectable} from "@angular/core";
import {UserMarketingRulesRepository} from "@app/core/user-marketing-rules/domain/user-marketing-rules-repository";
import {UserMarketingRules} from "@app/core/user-marketing-rules/domain/user-marketing-rules";
import {Clock} from "@app/core/shared/domain/clock";
import {Observable} from "rxjs";
import {switchMap} from "rxjs/operators";

/**
 * Use case to notify that the Download App message has been viewed.
 */
@Injectable({
    providedIn: "root",
})
export class NotifyDownloadAppMessageViewedUseCase {
    constructor(
        private userDataRepository: UserMarketingRulesRepository,
        private clock: Clock,
    ) {}

    execute(): Observable<void> {
        return this.userDataRepository.search().pipe(
            switchMap(userData => {
                const userDataToSave = userData ?? UserMarketingRules.create();
                userDataToSave.registerDownloadAppMessageViewed(this.clock);
                return this.userDataRepository.update(userDataToSave);
            })
        );
    }
}